import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';

// Add all solid icons to the library
library.add(fas);

/**
 * Parse FontAwesome CSS class and return icon definition
 * Converts "fal fa-chair" or "fas fa-cog" to ['fas', 'chair'] or ['fas', 'cog']
 * @param {string | null} iconString - CSS class string from API (e.g., "fal fa-chair")
 * @returns {[string, string] | null} Icon definition array or null
 */
export const parseFontAwesomeClass = (iconString) => {
  if (!iconString || typeof iconString !== 'string') {
    return null;
  }

  const cleanedString = iconString.trim();

  // Extract icon name from patterns like "fal fa-chair", "fas fa-cog", "fa-light fa-signature"
  const patterns = [
    /fa-([a-z0-9-]+)$/i, // Matches "fal fa-chair" → "chair"
    /fa-light\s+fa-([a-z0-9-]+)/i, // Matches "fa-light fa-signature" → "signature"
    /fa-solid\s+fa-([a-z0-9-]+)/i, // Matches "fa-solid fa-chair" → "chair"
  ];

  const iconName = /** @type {string | null} */ (
    patterns.reduce((result, pattern) => {
      if (result) return result;
      const matchResult = cleanedString.match(pattern);
      return matchResult && matchResult[1] ? matchResult[1] : null;
    }, null)
  );

  if (!iconName) {
    return null;
  }

  // Convert all to 'fas' (solid) since we only have pro-solid-svg-icons
  // fal (light), far (regular), fab (brands) → fas (solid)
  return /** @type {[string, string]} */ (['fas', iconName]);
};
